@if (collapsed()) {
  <!-- Coluna recolhida: faixa estreita com contagem e título na vertical. O botão de expandir
       tem a área de clique esticada pela faixa inteira (.kanban-expand-btn::after). -->
  <div
    class="kanban-board-container kanban-board-container--collapsed"
    [aionzTooltip]="collapsedTooltip()"
    aionzTooltipPosition="right"
    mode="message">
    <button
      mat-icon-button
      type="button"
      class="kanban-expand-btn"
      [attr.aria-label]="'Expandir coluna ' + title() + ' (' + filteredPurchases().length + ')'"
      aria-expanded="false"
      (click)="setCollapsed(false)">
      <mat-icon aria-hidden="true">keyboard_double_arrow_right</mat-icon>
    </button>
    <mat-basic-chip
      class="kanban-collapsed-count"
      [aionzPurchaseStatus]="boardId()"
      [attr.status]="boardId()"
      [attr.aria-label]="filteredPurchases().length + ' solicitações'"
      >{{ filteredPurchases().length }}</mat-basic-chip
    >
    <span
      class="kanban-collapsed-title"
      aria-hidden="true"
      >{{ title() }}</span
    >
  </div>
} @else {
  <div class="kanban-board-container">
    <div class="kanban-header">
      <div class="kanban-header-title">{{ title() }}</div>
      <div class="kanban-header-actions">
        @if (showAddButton()) {
          <mat-icon>add</mat-icon>
        }
        @if (showMenuButton()) {
          <mat-icon>more_vert</mat-icon>
        }
        <button
          mat-icon-button
          type="button"
          class="kanban-collapse-btn"
          [attr.aria-label]="'Recolher coluna ' + title()"
          aria-expanded="true"
          aionzTooltip="Recolher coluna"
          mode="message"
          (click)="setCollapsed(true)">
          <mat-icon aria-hidden="true">keyboard_double_arrow_left</mat-icon>
        </button>
      </div>
    </div>

    <div class="kanban-header-badges">
      <aionz-purchase-request-status
        [status]="boardId()"
        [count]="filteredPurchases().length" />
      @if (showSlaBadge() && showTimeBadge() && averageSlaLabel() !== '--') {
        <aionz-kanban-chip-badge
          [svgIcon]="'timelapse'"
          [label]="averageSlaLabel()"
          tooltip="Tempo médio que as solicitações ficam nesta etapa" />
      }
    </div>

    <div
      cdkDropList
      [cdkDropListDisabled]="!isDraggable()"
      [cdkDropListData]="filteredPurchases()"
      [id]="boardId()"
      class="cards-container"
      (cdkDropListDropped)="onDrop($event)"
      [cdkDropListConnectedTo]="boardStatuses()">
      @if (filteredPurchases().length === 0) {
        <p class="cards-empty">
          @if (searchTerm().trim()) {
            Nenhuma solicitação corresponde à busca nesta etapa.
          } @else {
            Nenhuma solicitação nesta etapa.
          }
        </p>
      }
      @for (purchase of filteredPurchases(); track $index) {
        <div
          cdkDrag
          [cdkDragDisabled]="!isDraggable()"
          [cdkDragData]="purchase"
          class="drag-item"
          [class.cursor-move]="isDraggable()"
          [class.cursor-pointer]="!isDraggable()">
          <div
            class="drag-placeholder"
            *cdkDragPlaceholder></div>
          <aionz-purchase-request-card
            [data]="purchase"
            (cardClicked)="cardClicked.emit($event)"
            (changeBuyer)="changeBuyer.emit($event)"
            (cancelPurchaseRequest)="cancelPurchaseRequest.emit($event)"
            (openAuditReport)="openAuditReport.emit($event)"
            (openQuotationMapPdf)="openQuotationMapPdf.emit($event)" />
        </div>
      }
    </div>
  </div>
}
